import { BreadcrumbListItem } from '@saucelabs/ds-breadcrumbs';

import { urls } from '../constants';
import { RectSize } from './types';

export enum ImageType {
  BASELINE = 'BASELINE',
  SNAPSHOT = 'SNAPSHOT'
}

export enum VisualErrorCodes {
  TIMEOUT = 'TIMEOUT',
  DIFF_TIMEOUT = 'DIFF_TIMEOUT',
}

export const VISUAL_TESTING_BREADCRUMB: BreadcrumbListItem = {
  name: 'Visual Testing',
};

export const VISUAL_ALL_BUILDS_BREADCRUMB: BreadcrumbListItem = {
  name: 'Builds',
  url: urls.getBuilds(),
};

export const MIN_RECT_SIZE: RectSize = {
  height: 8,
  width: 8,
};
